"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.geyYears = exports.getMonthDays = exports.formatInput = void 0;
var dateTime_1 = require("../../utils/dateTime");
function formatInput(date, inputDateFormat, dateFormat) {
    return (0, dateTime_1.isValidDate)(date, inputDateFormat)
        ? date
        : (0, dateTime_1.isValidDate)(date, dateFormat)
            ? (0, dateTime_1.replaceFormat)(date, dateFormat, inputDateFormat)
            : (0, dateTime_1.isValidDate)(date)
                ? (0, dateTime_1.replaceFormat)(date, undefined, inputDateFormat)
                : date;
}
exports.formatInput = formatInput;
function getMonthDays(month, year) {
    var firstMonthDate = new Date(year, month, 1).toISOString();
    var firstDayOfWeek = (0, dateTime_1.monthFirstDayOfWeek)(month, year);
    var daysCount = (0, dateTime_1.daysInMonth)(month, year);
    var days = Array.from({ length: 6 }).map(function () {
        return Array.from({ length: 7 }).map(function () { return ({
            day: 0,
            date: '',
        }); });
    });
    for (var i = 0; i < 42; i++) {
        var week = Math.floor(i / 7);
        var day = i % 7;
        if (i < firstDayOfWeek || i - firstDayOfWeek + 1 > daysCount)
            continue;
        days[week][day] = {
            day: i - firstDayOfWeek + 1,
            date: (0, dateTime_1.addDate)(firstMonthDate, i - firstDayOfWeek + 1),
        };
    }
    return days;
}
exports.getMonthDays = getMonthDays;
function geyYears() {
    var currentYear = new Date().getFullYear();
    var years = [currentYear];
    for (var i = 1; i <= 100; i++) {
        years.push(currentYear - i);
    }
    for (var i = 1; i <= 10; i++) {
        years.unshift(currentYear + i);
    }
    return years;
}
exports.geyYears = geyYears;
